<template>
  <div class="container">
    <el-card>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/personal/course'}">我的资源</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/resource/${$route.params.expId}`}">实验项目</el-breadcrumb-item>
        <el-breadcrumb-item>课堂实验</el-breadcrumb-item>
      </el-breadcrumb>
      <br>
      <el-table :data="expData" style="width: 100%">
        <el-table-column prop="lessonName" label="课堂名称"></el-table-column>
        <!-- <el-table-column prop="name" label="实验名称"></el-table-column>
        <el-table-column prop="reportNum" label="报告数"></el-table-column>
        <el-table-column prop="softNum" label="软件数"></el-table-column> -->
        <el-table-column label="标签">
          <template slot-scope="{ row }">
            <el-tag type="success" v-for="(item, index) in row.tagName" :key="index">{{ item }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="statusText" label="状态"></el-table-column>
      </el-table>
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        layout="total, prev, pager, next, jumper"
        :total="page.total"
        :current-page="page.page"
        :page-size="page.limit"
        :pager-count="page.pagerCount"
        @current-change="handlePageChange"
        style="margin-top:15px"
        hide-on-single-page
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLabExps } from "@/api/lab/experiment";

export default {
  data() {
    return {
      expData: [],
      page: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getList();
    },
    handlePageChange(page) {
      //分页
      this.$set(this.page, "page", page);
      this.getList();
    },
    getList() {
      // 获取课堂实验列表
      const { page, limit } = this.page;
      const { expUid } = this.$route.params;
      let params = {
        expUid
      };
      getLabExps(page, limit, params).then(res => {
        const { totalCount, list } = res;
        this.expData = list;
        this.$set(this.page, "total", totalCount);
      });
    }
  }
};
</script>
